import { call, put, takeLatest } from 'redux-saga/effects';

import * as donationActions from './donationActions.js';
import { updateDonationApiCall } from './donationAPI.js';

function* updateDonationSaga({ payload }) {
  try {
    const { data } = yield call(updateDonationApiCall, payload);
    yield put(donationActions.donationUpdateStore(data));
  } catch (error) {
    yield put(donationActions.donationUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* donationWatcher() {
  yield takeLatest(donationActions.donationUpdateRequest.type, updateDonationSaga);
}
